import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { UPDATE_PLC_SAFETY_TRIGGER } from './actionTypes';
import { updatePlcSafetyTriggerSuccessful, updatePlcSafetyTriggerFailed } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* updateTrigger({ payload: { trigger } }) {
  try {
    const response = yield call(plcSafetyAPI.updateTrigger, trigger.token, trigger.id, trigger);
    if (response.message) {
      yield put(updatePlcSafetyTriggerSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(updatePlcSafetyTriggerFailed(error));
  }
}

export function* watchUpdatePlcSafetyTrigger() {
  yield takeEvery(UPDATE_PLC_SAFETY_TRIGGER, updateTrigger);
}

function* updatePlcSafetyTriggerSaga() {
  yield all([fork(watchUpdatePlcSafetyTrigger)]);
}

export default updatePlcSafetyTriggerSaga;
